// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__us2RWt4fz7{display:inline-flex}.badge__NDRUARWToN{cursor:pointer}.tooltip__tn9LxiB0mf{max-width:250px}`, "",{"version":3,"sources":["webpack://./src/components/translationBadge/translationBadge.module.scss"],"names":[],"mappings":"AAAA,kBACE,mBAAA,CAGF,mBACE,cAAA,CAGF,qBACE,eAAA","sourcesContent":[".root {\n  display: inline-flex;\n}\n\n.badge {\n  cursor: pointer;\n}\n\n.tooltip {\n  max-width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__us2RWt4fz7`,
	"badge": `badge__NDRUARWToN`,
	"tooltip": `tooltip__tn9LxiB0mf`
};
export default ___CSS_LOADER_EXPORT___;
